import React, { useEffect, useState } from "react";
import { Link as DomLink } from "react-router-dom";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import api from "../../../utils/api";
import qs from "qs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import LandingFooter from "./LandingFooter";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { constants } from "../../../utils";
import { storage } from "../../../utils";

export default function StaticLanding(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [banner, setBanner] = useState();
  const [topgreen, setTopGreen] = useState();
  const [textblock, setTextBlock] = useState();
  const [threecards, setThreeCards] = useState();
  const [threeimages, setThreeImages] = useState();
  const [buttontextblock1, setButtonTextBlock1] = useState();
  const [imagecopyboxes, setImageCopyBoxes] = useState();
  const [buttontextblock2, setButtonTextBlock2] = useState();
  const [bottomgreen, setBottomGreen] = useState();
  const [icons, setIcons] = useState();

  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  const page =
    props.match.params.PageType === "Harmony"
      ? constants.HARMONY_ID
      : props.match.params.PageType === "Refining"
      ? constants.REFINING_ID
      : props.match.params.PageType === "Contract-Casting"
      ? constants.CONTRACT_CASTING_ID
      : props.match.params.PageType === "Findings"
      ? constants.FINDINGS_ID
      : props.match.params.PageType === "Bands"
      ? constants.BANDS_ID
      : props.match.params.PageType === "Bridal-Jewelry"
      ? constants.BRIDAL_ID
      : props.match.params.PageType === "Finished-Jewelry"
      ? constants.FINISHED_JEWELRY_ID
      : props.match.params.PageType === "Diamonds"
      ? constants.DIAMONDS_ID
      : props.match.params.PageType === "Refining-For-Dentists"
      ? constants.REFINING_FOR_DENTISTS
      : props.match.params.PageType === "Refining-For-Private-Individuals"
      ? constants.REFINING_FOR_PRIVATE_INDIVIDUALS
      : props.match.params.PageType === "Mill-Products"
      ? constants.MILL
      : 1;

  const LeftCopyBox = (leftCopyBox) => (
    <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
      <Stack direction="row" alignItems="center">
        <CardMedia
          sx={{ width: "50%" }}
          component="img"
          image={`${frontImageUrl}${leftCopyBox.image.data.attributes.url}`}
        />
        <CardContent sx={{ width: "50%" }}>
          <Stack spacing={3} sx={{ margin: "6rem" }}>
            <Typography variant="articleTitle" align="center">
              {leftCopyBox.title}
            </Typography>
            <Typography variant="staticText" align="center">
              <ReactMarkdown remarkGfm={[remarkGfm]}>
                {leftCopyBox.body}
              </ReactMarkdown>
            </Typography>
            {leftCopyBox.button && (
              <DomLink
                to={{
                  pathname: `${leftCopyBox.button.to}`,
                  state: {
                    recentlyViewed: JSON.parse(
                      storage.getSessionStorageItem("hsRecentlyViewedProducts")
                    ),
                  },
                }}
                className="center"
              >
                <Button variant="contained">{leftCopyBox.button.text}</Button>
              </DomLink>
            )}
          </Stack>
        </CardContent>
      </Stack>
    </Card>
  );

  const RightCopyBox = (rightCopyBox) => (
    <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
      <Stack direction="row" alignItems="center">
        <CardContent sx={{ width: "50%" }}>
          <Stack spacing={3} sx={{ margin: "6rem" }}>
            <Typography variant="articleTitle" align="center">
              {rightCopyBox.title}
            </Typography>
            <Typography variant="staticText" align="center">
              <ReactMarkdown remarkGfm={[remarkGfm]}>
                {rightCopyBox.body}
              </ReactMarkdown>
            </Typography>
            {rightCopyBox.button && (
              <DomLink
                to={{
                  pathname: `${rightCopyBox.button.to}`,
                  state: {
                    recentlyViewed: JSON.parse(
                      storage.getSessionStorageItem("hsRecentlyViewedProducts")
                    ),
                  },
                }}
                className="center"
              >
                <Button variant="contained">{rightCopyBox.button.text}</Button>
              </DomLink>
            )}
          </Stack>
        </CardContent>
        <CardMedia
          sx={{ width: "50%" }}
          component="img"
          image={`${frontImageUrl}${rightCopyBox.image.data.attributes.url}`}
        />
      </Stack>
    </Card>
  );

  const MobileCopyBox = (mobileCopyBox) => (
    <Card sx={{ backgroundColor: "#e3e3e3", width: "100%" }}>
      <Stack alignItems="center">
        <CardMedia
          component="img"
          image={`${frontImageUrl}${mobileCopyBox.image.data.attributes.url}`}
        />
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="articleTitle" align="center">
              {mobileCopyBox.title}
            </Typography>
            <Typography variant="staticText" align="center">
              <ReactMarkdown remarkGfm={[remarkGfm]}>
                {mobileCopyBox.body}
              </ReactMarkdown>
            </Typography>
            {mobileCopyBox.button && (
              <DomLink
                to={{ pathname: `${mobileCopyBox.button.to}` }}
                className="center"
              >
                <Button variant="contained">{mobileCopyBox.button.text}</Button>
              </DomLink>
            )}
          </Stack>
        </CardContent>
      </Stack>
    </Card>
  );

  const ThreeImagesCard = (image, pdf) => (
    <>
      {pdf === true ? (
        <a href={`${image.alternativeText}`} target="_blank" rel="noreferrer">
          <Card className="pointer" sx={{ backgroundColor: "#e3e3e3" }}>
            <CardMedia component="img" image={`${frontImageUrl}${image.url}`} />
            <Typography variant="imageCaption" className="center">
              {image.caption}
            </Typography>
          </Card>
        </a>
      ) : (
        <DomLink
          to={{
            pathname: `${image.alternativeText}`,
            state: {
              recentlyViewed: JSON.parse(
                storage.getSessionStorageItem("hsRecentlyViewedProducts")
              ),
            },
          }}
        >
          <Card className="pointer" sx={{ backgroundColor: "#e3e3e3" }}>
            <CardMedia component="img" image={`${frontImageUrl}${image.url}`} />
            <Typography variant="imageCaption" className="center">
              {image.caption}
            </Typography>
          </Card>
        </DomLink>
      )}
    </>
  );

  const ButtonTextBlock = (block) => (
    <Stack
      spacing={3}
      sx={
        block.background === "Blue"
          ? {
              backgroundColor: "#cfdde9",
              width: "100%",
              paddingBottom: "2rem",
            }
          : {
              backgroundColor: "inherit",
              width: "100%",
              paddingBottom: "2rem",
            }
      }
    >
      {block.optionalbannerimage.data !== null && (
        <img
          alt={block.optionalbannerimage.data.attributes.caption}
          src={`${frontImageUrl}${block.optionalbannerimage.data.attributes.url}`}
        />
      )}
      <Typography
        variant="articleTitle"
        align="center"
        sx={{ paddingTop: "2rem" }}
      >
        {block.title}
      </Typography>
      <Typography
        variant="staticText"
        align="center"
        sx={{ paddingLeft: "6rem", paddingRight: "6rem" }}
      >
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{block.body}</ReactMarkdown>
      </Typography>
      {block.pdf.data !== null ? (
        <a
          href={`${frontImageUrl}${block.pdf.data.attributes.url}`}
          download="test.pdf"
          target="_blank"
          className="center"
          rel="noreferrer"
        >
          <Button variant="contained">{block.button.text}</Button>
        </a>
      ) : (
        <DomLink
          to={{
            pathname: `${block.button.to}`,
          }}
          className="center"
        >
          <Button variant="contained">{block.button.text}</Button>
        </DomLink>
      )}
    </Stack>
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    const query = qs.stringify({
      populate: {
        banner: {
          populate: "*",
        },
        topgreen: {
          populate: "*",
        },
        textblock: {
          populate: "*",
        },
        threecards: {
          populate: "*",
        },
        threeimages: {
          populate: "*",
        },
        buttontextblock1: {
          populate: "*",
        },
        imagecopyboxes: {
          populate: "*",
        },
        buttontextblock2: {
          populate: "*",
        },
        bottomgreen: {
          populate: "*",
        },
        icons: {
          populate: "*",
        },
      },
    });
    api.fetchStrapi(`/landing-pages/${page}?${query}`).then((response) => {
      setBanner(
        response.data.data.attributes.banner.data
          ? response.data.data.attributes.banner.data.attributes
          : null
      );
      setTopGreen(response.data.data.attributes.topgreen);
      setTextBlock(response.data.data.attributes.textblock);
      setThreeCards(response.data.data.attributes.threecards);
      setThreeImages(response.data.data.attributes.threeimages);
      setButtonTextBlock1(response.data.data.attributes.buttontextblock1);
      setImageCopyBoxes(response.data.data.attributes.imagecopyboxes);
      setButtonTextBlock2(response.data.data.attributes.buttontextblock2);
      setBottomGreen(response.data.data.attributes.bottomgreen);
      setIcons(response.data.data.attributes.icons);
      setIsLoaded(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.PageType]);

  return (
    <>
      {!isLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl" className="careers-text">
          <Mobile>
            <Stack spacing={3} alignItems="center">
              {banner && (
                <img
                  src={`${frontImageUrl}${banner.formats.large.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              {topgreen && (
                <Typography variant="mobileGreenRectangle" align="center">
                  {topgreen.text}
                </Typography>
              )}
              {threecards && threecards.length > 0 && (
                <Stack spacing={4}>
                  {threecards.map((card) => (
                    <DomLink
                      to={{
                        pathname: `${card.link}`,
                      }}
                    >
                      <Card variant="outlined" sx={{ width: "25%" }}>
                        <img
                          src={`${frontImageUrl}${card.icon.data.attributes.url}`}
                          alt="left"
                          style={{ paddingTop: "2rem" }}
                        />
                        <CardContent>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                              {card.link}
                            </ReactMarkdown>
                          </Typography>
                        </CardContent>
                      </Card>
                    </DomLink>
                  ))}
                </Stack>
              )}
              <Stack
                spacing={3}
                sx={
                  textblock.background === "Blue"
                    ? {
                        backgroundColor: "#cfdde9",
                        width: "100%",
                        paddingBottom: "2rem",
                      }
                    : {
                        backgroundColor: "inherit",
                        width: "100%",
                        paddingBottom: "2rem",
                      }
                }
              >
                <Typography
                  variant="articleTitle"
                  align="center"
                  sx={{ paddingTop: "2rem" }}
                >
                  {textblock.title}
                </Typography>
                <Typography variant="staticText" align="center">
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {textblock.body}
                  </ReactMarkdown>
                </Typography>
              </Stack>
              {threeimages.map((threeimages) => (
                <Stack key={threeimages.id} spacing={2}>
                  {ThreeImagesCard(
                    threeimages.image1.data.attributes,
                    threeimages.image1pdf
                  )}
                  {ThreeImagesCard(
                    threeimages.image2.data.attributes,
                    threeimages.image2pdf
                  )}
                  {ThreeImagesCard(
                    threeimages.image3.data.attributes,
                    threeimages.image3pdf
                  )}
                </Stack>
              ))}
              {buttontextblock1 ? ButtonTextBlock(buttontextblock1) : ""}
              {imagecopyboxes.map((copyBox) => (
                <React.Fragment key={copyBox.id}>
                  {MobileCopyBox(copyBox)}
                </React.Fragment>
              ))}
              {ButtonTextBlock(buttontextblock2)}
              <Typography variant="mobileGreenRectangle" align="center">
                {bottomgreen.text}
              </Typography>
              <LandingFooter icons={icons} />
            </Stack>
          </Mobile>
          <Default>
            <Stack spacing={3} alignItems="center">
              {banner && (
                <img
                  src={`${frontImageUrl}${banner.formats.large.url}`}
                  width="100%"
                  alt="banner"
                />
              )}
              {topgreen && (
                <Typography variant="greenRectangle" align="center">
                  {topgreen.text}
                </Typography>
              )}
              {threecards && threecards.length > 0 && (
                <Stack direction="row" spacing={4}>
                  {threecards.map((card) => (
                    <DomLink
                      to={{
                        pathname: `${card.link}`,
                      }}
                    >
                      <Card variant="outlined" sx={{ width: "25%" }}>
                        <img
                          src={`${frontImageUrl}${card.icon.data.attributes.url}`}
                          alt="left"
                          style={{ paddingTop: "2rem" }}
                        />
                        <CardContent>
                          <Typography variant="staticText">
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                              {card.link}
                            </ReactMarkdown>
                          </Typography>
                        </CardContent>
                      </Card>
                    </DomLink>
                  ))}
                </Stack>
              )}
              <Stack
                spacing={3}
                sx={
                  textblock.background === "Blue"
                    ? {
                        backgroundColor: "#cfdde9",
                        width: "100%",
                        paddingBottom: "2rem",
                      }
                    : {
                        backgroundColor: "inherit",
                        width: "100%",
                        paddingBottom: "2rem",
                      }
                }
              >
                <Typography
                  variant="articleTitle"
                  align="center"
                  sx={{ paddingTop: "2rem" }}
                >
                  {textblock.title}
                </Typography>
                <Typography
                  variant="staticText"
                  align="center"
                  sx={{ paddingLeft: "6rem", paddingRight: "6rem" }}
                >
                  <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {textblock.body}
                  </ReactMarkdown>
                </Typography>
              </Stack>
              {threeimages.map((threeimages) => (
                <Stack direction="row" key={threeimages.id} spacing={2}>
                  {ThreeImagesCard(
                    threeimages.image1.data.attributes,
                    threeimages.image1pdf
                  )}
                  {ThreeImagesCard(
                    threeimages.image2.data.attributes,
                    threeimages.image2pdf
                  )}
                  {ThreeImagesCard(
                    threeimages.image3.data.attributes,
                    threeimages.image3pdf
                  )}
                </Stack>
              ))}
              {buttontextblock1 ? ButtonTextBlock(buttontextblock1) : ""}
              {imagecopyboxes.map((copyBox) => (
                <React.Fragment key={copyBox.id}>
                  {copyBox.alignment === "left" ? (
                    <>{LeftCopyBox(copyBox)}</>
                  ) : (
                    <>{RightCopyBox(copyBox)}</>
                  )}
                </React.Fragment>
              ))}
              {ButtonTextBlock(buttontextblock2)}
              <Typography variant="greenRectangle" align="center">
                {bottomgreen.text}
              </Typography>
              <LandingFooter icons={icons} />
            </Stack>
          </Default>
        </Container>
      )}
    </>
  );
}
